import { Box, Heading, Paragraph, Spinner } from '@zillow/constellation-10';

const AiDraftingState = () => (
  <Box
    data-testid="AiDraftingState"
    css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '500' }}
  >
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'default',
        padding: 'default',
        maxWidth: '584px',
        width: '100%',
      }}
    >
      <Spinner size="lg" title="Drafting your property description" />
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'tightest',
          textAlign: 'center',
          width: '100%',
        }}
      >
        <Heading level={2} textStyle="heading-xs">
          We’re working on your property description
        </Heading>
        <Paragraph textStyle="body-sm">
          We’re using your photos, notes, and property data to draft your property description. Check back in a couple
          of minutes, and it should be ready for review.
        </Paragraph>
      </Box>
    </Box>
  </Box>
);

export default AiDraftingState;
